<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">

      <el-tag class="mb-5">{{username}}</el-tag>

      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="修改用户名" name="first" class="oneTab">
          <span class="title">用户名:</span>
          <el-input v-model="username" placeholder="请输入用户名" class="username"></el-input>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second" class="oneTab">
          <span class="title">密码类型:</span>
          <muserPtypeSelect @setPtype="getPtype"></muserPtypeSelect>
        </el-tab-pane>
        <el-tab-pane label="修改/绑定手机号" name="third" class="oneTab">
          <span class="title">手机号:</span>
          <el-input v-model="phone" placeholder="请输入手机号(选填)" type="number" class="phone_input"></el-input>
        </el-tab-pane>
        <el-tab-pane label="修改权限" name="fourth">
          <MuserRoleConfigBox ref="MuserRoleConfigBox"></MuserRoleConfigBox>
        </el-tab-pane>
        <el-tab-pane label="绑定用户" name="fifth">
          <MuserUserBind ref="MuserUserBind"></MuserUserBind>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card class="form_box__main_box__input_group mt-2" v-show="showButton">
      <el-button style="margin-top: 12px;" type="primary" @click="save" >更新</el-button>
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import {
  muserEditInitApi,
  muserEditUsernameApi,
  muserEditPasswordApi,
  muserEditRoleApi,
  muserEditPhoneApi,
} from "@/api/module/muser/muser";
import Base64 from "js-base64";
import { muserPtypeSelect, MuserUserBind, MuserRoleConfigBox } from "@/views/module/muser/component/index";

export default {
  name: "MuserAdd", // 注意：这个组件名称为MuserAdd，但功能是编辑，可能需要改为MuserEdit
  
  mixins: [BaseVue],
  
  components: {
    muserPtypeSelect,
    MuserUserBind,
    MuserRoleConfigBox,
  },
  
  data() {
    return {
      loading: false,
      username: "",
      type: "", // 权限选中列表
      ptype: "0", // 密码类型
      password: "",
      rpassword: "", // 校验密码
      id: "",
      phone: "", // 手机号
      activeName: "first", // 导航默认选中第一个
      companyIdArr: []
    };
  },
  
  computed: {
    showButton() {
      if (this.activeName == "fifth" || this.activeName == "fourth") {
        return false;
      } else {
        return true;
      }
    }
  },
  
  methods: {
    // 获取权限类型
    getType(e) {
      console.log("this is e", e);
      this.type = e;
    },
    
    // 获取密码相关信息
    getPtype(e) {
      this.password = e.password;
      this.rpassword = e.rpassword;
      this.ptype = e.ptype;
    },
    
    save() {
      if (this.activeName == "first") {
        if (this.username.length <= 0) {
          this.$message.error("请输入用户名！");
          return false;
        }
        let username = this.username;
        let id = this.id;
        let data = {
          username,
          id,
        };
        muserEditUsernameApi(data)
          .then((res) => {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/standard/muser/muserList",
              });
            }, 1500);
          })
          .catch((err) => {
            console.log(err);
            return false;
          });
      }
      if (this.activeName == "second") {
        if (this.ptype == 1) {
          if (this.password.length <= 0) {
            this.$message.error("请填写密码！");
            return false;
          }
          if (this.password != this.rpassword) {
            this.$message.error("两次密码不一致！");
            return false;
          }
        }
        let p = Base64.Base64.encode(this.password); // 加密后的密码
        let data = {
          id: this.id,
          ptype: this.ptype,
          p,
        };
        muserEditPasswordApi(data)
          .then((res) => {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/standard/muser/muserList",
              });
            }, 1500);
          })
          .catch((err) => {
            console.log(err);
            return false;
          });
      }
      if (this.activeName == "third") {
        if (!/^1[3456789]\d{9}$/.test(this.phone) && this.phone) {
          this.$message.error("手机号码有误，请重填！");
          return false;
        }
        let data = {
          id: this.id,
          phone: this.phone,
        };
        muserEditPhoneApi(data)
          .then((res) => {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/standard/muser/muserList",
              });
            }, 1500);
          })
          .catch((err) => {
            return false;
          });
      }
      if (this.activeName == "fourth") {
        // 权限编辑逻辑
      }
    }
  },
  
  watch: {
    activeName(newVal) {
      if (newVal == "fourth") {
        this.$refs.MuserRoleConfigBox.init();
      }
      if (newVal == "fifth") {
        this.$refs.MuserUserBind.init();
      }
    }
  },
  
  created() {
    // 组件创建时的逻辑
  },
  
  mounted() {
    this.id = this.$route.query.id;
    
    console.log("muser edit");
    
    this.$refs.MuserUserBind.initMUid(this.id);
    this.$refs.MuserRoleConfigBox.initMUid(this.id);
    
    muserEditInitApi(this.id)
      .then((response) => {
        this.username = response.username;
        this.type = response.type;
        this.phone = response.phone;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped lang="scss">
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  width: 120px;
  padding-left: 10px;
  box-sizing: border-box;
}
.oneTab {
  display: flex;
  align-items: center;
}
.username {
  width: 200px;
}
.phone_input {
  width: 200px;
  & ::v-deep input::-webkit-outer-spin-button,
  & ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  & ::v-deep input[type="number"] {
    -moz-appearance: textfield;
  }
}
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}

</style>

